import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PagePanel, Button, ButtonSize, EditIcon, Box } from 'edenred-ui';
import { useTheme } from 'styled-components';

import * as navigationActions from '@epi-actions/navigation';
import DisplayAddress from '@epi-components/Address/DisplayAddress';
import { CompanyProps } from '@epi-models/components/Company';

import { businessId as businessIdFormatter } from '../../helpers/formHelpers/formatters';
import { RoundButton } from '../RoundButton/RoundButton';
import { LoadingContainer } from '../LoadingContainer/LoadingContainer';

import './Company.scss';

const Company = ({
  userCompany,
  editPage = '',
  goToPage = () => null,
  isLoading = false
}: CompanyProps) => {
  const { t } = useTranslation();
  const { businessIdentityCode, name, address } = userCompany;
  const { gray50, sizeMedium } = useTheme();

  return (
    <div className="Company">
      <PagePanel
        title={t('containers.voucher_order.company_information_header')}
        className="px-10"
      >
        {editPage && (
          <span className="visible-xs-inline">
            <RoundButton
              id="company-edit-icon-btn"
              icon={<EditIcon />}
              className="pull-right"
              onClick={() => goToPage(editPage)}
            />
          </span>
        )}
        <LoadingContainer isLoading={isLoading}>
          <Box pl={3} color={gray50} fontSize={sizeMedium}>
            <div>{`${name} ${businessIdFormatter(businessIdentityCode)}`}</div>
            <DisplayAddress address={address} />
          </Box>
          {editPage && (
            <Box mt={2}>
              <Button
                id="company-edit-btn"
                className="btn-edit pull-right"
                onClick={() => goToPage(editPage)}
                size={ButtonSize.Medium}
              >
                {t('components.benefit_summary.edit')}
              </Button>
            </Box>
          )}
        </LoadingContainer>
      </PagePanel>
    </div>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...navigationActions }, dispatch);

const ConnectedCompany = connect(null, mapDispatchToProps)(Company);

export { ConnectedCompany as Company };
